var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3423 4.312C11.644 3.01026 13.7546 3.01026 15.0563 4.312L15.6875 4.94313C16.9892 6.24488 16.9892 8.35544 15.6875 9.65718L9.93238 15.4122C9.70119 15.6434 9.4071 15.8015 9.08673 15.8668L5.33374 16.6317C4.16328 16.8703 3.12925 15.8363 3.36778 14.6658L4.13262 10.9127C4.19792 10.5924 4.35601 10.2982 4.58722 10.067L10.3423 4.312ZM13.8778 5.49051C13.2269 4.83964 12.1717 4.83964 11.5208 5.49051L11.1778 5.83355L14.1659 8.8217L14.5089 8.47867C15.1598 7.8278 15.1598 6.77252 14.5089 6.12164L13.8778 5.49051ZM7.01108 10.0002L9.99925 7.01206L12.9874 10.0002L9.99924 12.9884L7.01108 10.0002ZM5.83257 11.1787L5.76573 11.2456L5.00088 14.9986L8.75387 14.2337L8.82072 14.1669L5.83257 11.1787Z",
    fill: "#3F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ef40bf0639700072a344c4fc391d2f1e.svg";
export { ForwardRef as ReactComponent };